export default __webpack_public_path__ + "static/media/laundry2-after-1920w.0a85f5fe.avif";